import { Controller } from 'stimulus';

// Marks a mural announcement as seen the moment its card scrolls into the
// viewport. Fires once, then disconnects the observer.
export default class extends Controller {
  static values = { url: String };

  connect() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        this.markSeen();
        this.observer.disconnect();
      });
    }, { threshold: 0.5 });
    this.observer.observe(this.element);
  }

  disconnect() {
    if (this.observer) this.observer.disconnect();
  }

  markSeen() {
    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    fetch(this.urlValue, {
      method: 'POST',
      headers: { 'X-CSRF-Token': token, Accept: 'text/vnd.turbo-stream.html' }
    });
  }
}
